import './workingDetailsCard.scss';
import employeeImage from '../../../assets/icons/employee.png';
import repeatImage from '../../../assets/icons/repeat.png';
import { useNavigate } from 'react-router-dom';
import { IEmpInfoData, ISchList } from 'types/listOfEmployees';
import useAlertConfirmStore from 'zustands/useAlertConfirmStore';

interface IWorkingDetailsCard {
  weeks?: string;
  days: string;
  time: string;
  breakHours?: string;
  hours: string;
  removeBtnText?: string;
  modifyBtnText?: string;
  infoData?: IEmpInfoData;
  thisSch?: ISchList;
  onRemove?: () => void;
}
const WorkingDetailsCard = ({
  weeks = '',
  days,
  time,
  hours,
  breakHours,
  infoData,
  thisSch,
  removeBtnText = '',
  modifyBtnText = '',
  onRemove,
}: IWorkingDetailsCard) => {
  const navigate = useNavigate();
  const { setModalState } = useAlertConfirmStore();

  return (
    <div className="workingDetailsCard">
      <div className="container">
        <div className="employeeImageWrapper">
          <img src={employeeImage} alt="" className="employeeImage" />
        </div>

        <div className="timeContainer">
          <div className="rowOne">
            <div className="repeatImage">
              <img src={repeatImage} alt="" className="employeeImage" />
            </div>

            {weeks && (
              <>
                <div className="weekCount">{weeks}</div>
                <div className="divider" />
              </>
            )}
            <div className="days">{days}</div>
          </div>

          <div className="rowTwo">
            <div className="time">{time}</div>
            {breakHours && <div className="break">({breakHours})</div>}
          </div>
        </div>

        <div
          className="hoursContainer"
          style={{ justifyContent: removeBtnText.length > 0 ? 'space-between' : 'center' }}>
          <div className="btn-box">
            {modifyBtnText.length > 0 && (
              <div className="modify">
                <button
                  onClick={() => {
                    setModalState({
                      isModalShow: true,
                      title: '근무일정 수정',
                      desc: '설정된 일정이 잘못된 경우에만 "수정"을 진행해 주세 요. 기존 출퇴근, 급여 데이터가 변동될 수 있습니다. \n\n* 기존에 설정된 근무시간, 요일이 아닌 다른 일정으로 근무하게 되는 경우 근무 일정을 "추가"해 주세요.',
                      okBtnText: '확인',
                      okCallback: () => {
                        navigate('/work-schedule', {
                          state: {
                            empData: infoData,
                            schData: thisSch,
                            formType: '근무일정수정',
                          },
                        });
                      },
                      isWarning: false,
                    });
                  }}>
                  {/* onClick={() => {
                    
                    navigate('/work-schedule', {
                      state: {
                        empData: infoData,
                        schData: thisSch,
                        formType: '근무일정수정',
                      },
                    }); 
                  }}> */}

                  {modifyBtnText}
                </button>
              </div>
            )}
            {removeBtnText.length > 0 && (
              <div className="remove">
                <button onClick={onRemove}>{removeBtnText}</button>
              </div>
            )}
          </div>
          <div className="hoursText">{hours}</div>
        </div>
      </div>
    </div>
  );
};

export default WorkingDetailsCard;
